import type { RoleTag } from "../app/services/roles";
import type { ShotTag } from "../app/services/projects";

/**
 * `RoleTag` を `FilterChipBar` に渡すための `ShotTag` 形に変換するアダプタ。
 *
 * ロールタグのフィルタ UI は元々プロジェクト内のショット用タグ (`ShotTag`) を
 * 前提に作られているため、ロールタグを汎用フィルタ UI で使う場面では本アダプタを
 * 通す。`id` の文字列化と、ロールタグでは持たない `sort_rule` / `position` の
 * 補完を行う。
 */
export const roleTagToShotTag = (tag: RoleTag): ShotTag => ({
  id: String(tag.id),
  name: tag.name,
  sort_rule: "newest",
  position: tag.order,
});
